import React from "react";
import PaymentKlarna from "../../resources/images/payment-klarna.png";
import PaymentPaypal from "../../resources/images/payment-paypal.png";
import PaymentMastercard from "../../resources/images/payment-mastercard.png";
import PaymentVisa from "../../resources/images/payment-visa.png";

/* TODO: Use content model for each payment item, remove everything hardcoded, incl. the images. */
export default () =>
    <ul className="m-payment-list u-list-unstyled">
        <li className="m-payment-list__item">
            <img className="m-payment-list__logo" src={ PaymentKlarna } alt="Klarna logo"/>
            <span className="u-visually-hidden">Klarna</span>
        </li>
        <li className="m-payment-list__item">
            <img className="m-payment-list__logo" src={ PaymentMastercard } alt="Master card logo"/>
            <span className="u-visually-hidden">Mastercard</span>
        </li>
        <li className="m-payment-list__item">
            <img className="m-payment-list__logo" src={ PaymentVisa } alt="Visa logo"/>
            <span className="u-visually-hidden">Visa</span>
        </li>
    </ul>;